import { render, staticRenderFns } from "./ActionItems.vue?vue&type=template&id=3a23b349&scoped=true&"
import script from "./ActionItems.vue?vue&type=script&lang=ts&"
export * from "./ActionItems.vue?vue&type=script&lang=ts&"
import style0 from "./ActionItems.vue?vue&type=style&index=0&id=3a23b349&lang=scss&scoped=true&"
import style1 from "./ActionItems.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a23b349",
  null
  
)

export default component.exports